import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface OPDExitAware {
  canExitOPD: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({ providedIn: 'root' })
export class OPDExitGuard implements CanDeactivate<OPDExitAware> {

  canDeactivate(component: OPDExitAware) {
    return component.canExitOPD();
  }
  
}